import axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { ApiHelper } from "../../common/helpers/ApiHelper";
import { SiteSessionService } from "../../core/services/SiteSessionService";
import { getMsalInstance } from "../../msalProvider";

// template client with authorized api calls
export const authTemplateApiAxios = () => {
    const axiosClient = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_API,
    });

    const requestConfigAuthMiddleware = (requestConfig: AxiosRequestConfig<any>) => {
        console.log("request middleware");
        requestConfig.headers = {
            Authorization: `Bearer ${SiteSessionService.getAccessToken()}`,
            "Content-Type": "application/json",
            UserId: SiteSessionService.getUserID(),
        };
        return requestConfig;
    };

    const responseErrorHandler = (error: any) => {
        console.error("There was a server error in responding to a request");
    };

    const requestConfigErrorMiddleware = (error: any) => {
        console.error(error);
    };

    axiosClient.interceptors.request.use(requestConfigAuthMiddleware, requestConfigErrorMiddleware);
    axiosClient.interceptors.response.use(
        async (response) => {
            // If the response is successful, just return it
            console.log("All responses come here");
            if (response.status == 401) {
                try {
                    //window.location.href = '/';
                    const msalInstance = getMsalInstance();
                    const account = msalInstance.getAllAccounts()[0];
                    // if (!account) {
                    //     throw new Error("No account found. User must sign in.");
                    // }

                    const authResult = await msalInstance.acquireTokenSilent({
                        scopes: [`api://${process.env.REACT_APP_API_CLIENT_ID}/ClaimConnect.ReadWrite`],
                        account,
                    });
                    console.log(authResult.accessToken);

                    SiteSessionService.setAccessToken(authResult.accessToken);
                    const retryConfig = {
                        ...response.config,
                        headers: {
                            ...response.config.headers,
                            Authorization: `Bearer ${authResult.accessToken}`,
                        },
                    };
                    return axiosClient(retryConfig);
                } catch (authError) {
                    return Promise.reject(authError);
                }
            } else {
                return response;
            }
        },
        async (error) => {
            // Check if the error response exists and if the status is 401
            if (error.response && error.response.status === 401) {
                console.error("Unauthorized - redirecting to login.");
                // Redirect to login page
                window.location.href = "/"; // Adjust the path as needed
            }
            // Reject the promise with the error
            return Promise.reject(error);
        }
    );

    return axiosClient;
};
